<template>
    <div class="
            space-y-4 md:space-y-0 md:space-x-8 md:px-16 py-4
            text-ncfic-blue-500 border-t border-ncfic-blue-100 bg-white flex flex-col md:flex-row justify-between items-center px-4 w-full md:h-14 z-50
            dark:text-ncfic-blue-100 dark:border-gray-600 dark:bg-gray-800
            print:hidden
    ">

        <div></div>
        <!-- <router-link to="/about/60cd1a416d05214482e37bff/" class="lg:w-32 hover:underline text-xs">Transaction Policy</router-link> -->

        <div class="flex flex-col items-center md:flex-row space-y-4 md:space-y-0 md:space-x-8 text-xs md:text-sm">
            <div>© {{ (new Date()).getFullYear() }}<span class="hidden lg:inline"> Scott Brown Online</span></div>
            <div class="w-full md:w-auto flex justify-center">
                <a href="https://www.facebook.com/sbrownonline/" rel="nofollow" target="_blank">
                    <i class="fab fa-facebook-f m-2 hover:text-ncfic-green cursor-pointer"></i>
                </a>
                <a href="https://twitter.com/sbrownonline" rel="nofollow" target="_blank">
                    <i class="fab fa-twitter m-2 hover:text-ncfic-green cursor-pointer"></i>
                </a>
                <a href="https://www.instagram.com/sbrownonline/" rel="nofollow" target="_blank">
                    <i class="fab fa-instagram m-2 hover:text-ncfic-green cursor-pointer"></i>
                </a>
            </div>
            <button class="hover:underline" @click="contactUs = true">Contact Us</button>
            <a class="hover:underline" href="tel:919-867-1980">(919) 867-1980</a>
            <!-- <router-link to="/donate" class="block hover:underline">Donate</router-link> -->
        </div>

        <div></div>

        <Modal @hide="contactUs = false" :active="contactUs">
            <Contact @sent="contactUs = false" />
        </Modal>

    </div>
</template>

<script>
import Contact from '../../helpers/contact.vue'
import Modal from '../layout/modal.vue'
export default {
    components: {Contact, Modal},
    data() {
        return {
            contactUs: false,
        }
    },
    created() {
        setTimeout(() => {
            if (this.$route.hash == '#contact') {
                this.contactUs = true
            }
        }, 500)
    }
}
</script>
